import React from 'react';
import Icon from '@/shared/components/Icon/Icon';
import styles from './LoadingSpinner.module.css';

const LoadingSpinner: React.FC = ({}) => {
  return (
    <div className={styles.main}>
      <Icon size="xxlLarge" color="primary" src="assets/icons/spaceShuttle.svg" className={styles.icon} />
    </div>
  );
};

export default LoadingSpinner;
